const resolveComposerScopeKey = (payload) => {
  const sk = String(payload?.scopeKey || '').trim();
  if (sk) {
    return sk;
  }
  const tid = String(payload?.threadId || '').trim();
  if (tid) {
    return `thread:${tid}`;
  }
  return 'active';
};

export default resolveComposerScopeKey;
